// extracted by mini-css-extract-plugin
module.exports = {"container":"_26gqkAWXi31OPHFJorgtBY","name":"_2jnYsFMxaOBuUdYloF_sTM appTitle","products":"_3Zdb7JGRIW_R1_WECqJLpl","menuProductCol":"_1dP2k05LWeqdqKCmndjPLS"};